import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';

import { isAxiosAccountingError } from 'store/utils/isAxiosAccountingError';
import { NotificationActions } from 'domains/notifications/store/NotificationActions';
import { isTFAError } from 'modules/tfa/utils/isTFAError';

import { getAccountErrorMessage } from '../../utils/getAccountErrorMessage';

export const errorHandlerWithNotification = <TArgs>(
  error: unknown,
  args: TArgs,
  queryApi: BaseQueryApi,
) => {
  const errorMessage = isAxiosAccountingError(error)
    ? getAccountErrorMessage(error)
    : undefined;

  // if error is 2fa, we don't show notification
  const is2faError = isTFAError(error);

  if (errorMessage && !is2faError) {
    queryApi.dispatch(
      NotificationActions.showNotification({
        message: errorMessage,
        severity: 'error',
      }),
    );
  }

  return { error, args, queryApi };
};
